// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { Alert, Avatar, Box, Button, Card, CardContent, TextField, Drawer, IconButton, Typography, Fade } from '@mui/material';
// // import OutlinedInput from '@mui/material/OutlinedInput';
// import axios from 'axios';
// // import api from '../../../services/api';
// import api from '../../services/api';

// // import { use } from 'react';
// // import { IconPlus, IconArrowRight } from '@tabler/icons';

// import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
// import AttachFileIcon from '@mui/icons-material/AttachFile';
// import SendIcon from '@mui/icons-material/Send';
// import MicIcon from '@mui/icons-material/Mic';

// // material-ui
// import { makeStyles } from '@mui/styles';
// import useTheme from '@mui/material/styles/useTheme';

// import Badge from '@mui/material/Badge';
// // import MailIcon from '@mui/icons-material/Mail';

// //? IMPORT TABS
// import PropTypes from 'prop-types';
// import { styled } from '@mui/material/styles';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';

// //? Negócios
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// // import DealConversationCard from '../../../DealConversationCard';
// import DealConversationCard from '../authentication/conversas/DealConversationCard';
// import DealCard from '../authentication/conversas/DealCard';
// // import JanelaConversa from '../JanelaConversa';
// import JanelaConversa from '../../pages/authentication/conversas/JanelaConversa';
// import NewDeal from './NewDeal';

// import DealDrawer from './DealDrawer';

// // style constant
// const useStyles = makeStyles((theme) => ({
//     root: {
//         display: 'flex'
//     },
//     appBar: {
//         backgroundColor: '#0A1828', //theme.palette.background.default, //#0A1828 //#2B2C4A
//         zIndex: theme.zIndex.drawer + 1,
//         height: 48,
//         transition: theme.transitions.create(['top'], {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen
//         })
//     },
//     conversationBar: {
//         background: '#161818',
//         color: '#e60000'
//     },
//     toolbar: {
//         minHeight: 48
//     },
//     appBarWidth: {
//         transition: theme.transitions.create('width'),
//         backgroundColor: theme.palette.background.default
//     },
//     content: {
//         ...theme.typography.mainContent,
//         borderBottomLeftRadius: 0,
//         borderBottomRightRadius: 0,
//         transition: theme.transitions.create('margin', {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen
//         }),
//         [theme.breakpoints.up('md')]: {
//             // marginLeft: -(drawerWidth - 20),
//             // width: `calc(100% - ${drawerWidth}px)`
//         },
//         [theme.breakpoints.down('md')]: {
//             marginLeft: '20px',
//             // width: `calc(100% - ${drawerWidth}px)`,
//             padding: '16px'
//         },
//         [theme.breakpoints.down('sm')]: {
//             marginLeft: '10px',
//             // width: `calc(100% - ${drawerWidth}px)`,
//             padding: '16px',
//             marginRight: '10px'
//         }
//     },
//     contentShift: {
//         transition: theme.transitions.create('margin', {
//             easing: theme.transitions.easing.easeOut,
//             duration: theme.transitions.duration.enteringScreen
//         }),
//         marginLeft: 0,
//         borderBottomLeftRadius: 0,
//         borderBottomRightRadius: 0,
//         [theme.breakpoints.down('md')]: {
//             marginLeft: '20px'
//         },
//         [theme.breakpoints.down('sm')]: {
//             marginLeft: '10px'
//         }
//     }
// }));

// const PipelineMain = () => {
//     // const [user, setUser] = useState('');

//     const user = useSelector((state) => state.account.user);

//     const classes = useStyles();

//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const [status, setStatus] = useState({ type: '', message: '' });

//     //?NEGÓCIOS
//     const [negocio, setNegocio] = useState({});
//     const [pipelines, setPipelines] = useState([]);
//     const [pipelineId, setPipelineId] = useState(null);
//     const [stages, setStages] = useState([]);
//     const [dealsByStage, setDealsByStage] = useState({}); // { stageId: [deals] }
//     const [selectedDeal, setSelectedDeal] = useState(null);
//     const [openDrawer, setOpenDrawer] = useState(false);
//     const [openBox, setOpenBox] = useState(false);
//     const [openNewDealDrawer, setOpenNewDealDrawer] = useState(false);
//     const [openDealDrawer, setOpenDealDrawer] = useState(false);
//     const [closeDealDrawer, setCloseDealDrawer] = useState(false);

//     //?APP
//     const [appId, setAppId] = useState();

//     //?CONVERSAS
//     const [conversaSelecionada, setConversaSelecionada] = useState(null);
//     const [conversationsNew, setConversationsNew] = useState([]);
//     const [conversationsOpen, setConversationsOpen] = useState([]);
//     const [conversationsInProgress, setConversationsInprogress] = useState([]);
//     const [conversationsPending, setConversationsPending] = useState([]);
//     const [conversationsClosed, setConversationsClosed] = useState([]);
//     const [selectedConversation, setSelectedConversation] = useState(null);

//     const [qtdConvNew, setQtdConvNew] = useState(0);
//     const [qtdConvOpen, setQtdConvOpen] = useState(0);
//     const [qtdConvInProgress, setQtdConvInProgress] = useState(0);
//     const [qtdConvPending, setQtdConvPending] = useState(0);
//     const [qtdConvClosed, setQtdConvClosed] = useState(0);

//     //?MENSAGENS
//     const [messages, setMessages] = useState([]);
//     const [inputMessage, setInputMessage] = useState('');

//     //? TABS
//     const [value, setValue] = React.useState(0);
//     const [value2, setValue2] = React.useState(0);

//     const pegar_app_padrao = async () => {
//         // console.log('entrou em pegar app padrao');
//         try {
//             const response = await api.get('v1/apps/default/');
//             const data = response.data;

//             setAppId(data.app.id);
//         } catch (error) {
//             console.error(error);
//         }
//     };

//     //? ------------ USE EFFECTS ------------------------
//     useEffect(() => {
//         if (!localStorage.getItem('access_token')) return;
//         pegar_app_padrao();
//     }, []);

//     useEffect(() => {
//         if (!localStorage.getItem('access_token')) return;
//         if (!appId) return;
//         pegar_conversas();
//         // pegar_negocios();
//         loadPipeline();
//     }, [appId]);

//     useEffect(() => {
//         if (!localStorage.getItem('access_token')) return;
//         if (!appId) return;

//         const interval = setInterval(() => {
//             pegar_conversas();
//             // pegar_negocios();
//             loadPipeline();
//         }, 3000);

//         return () => clearInterval(interval);
//     }, [appId]);

//     useEffect(() => {
//         if (!localStorage.getItem('access_token')) return;

//         if (!selectedConversation || !appId) return;

//         pegar_mensagens_conversa();

//         const interval = setInterval(() => {
//             pegar_mensagens_conversa();
//         }, 3000);

//         return () => clearInterval(interval);
//     }, [selectedConversation?.id, appId]);

//     //? -------------------------------------------

//     const pegar_conversas = async () => {
//         if (!appId) {
//             console.warn('pegar_conversas abortado: appId indefinido');
//             return;
//         }

//         try {
//             const response = await api.get(`v1/apps/${appId}/conversations/`);
//             if (response.data) {
//                 const list_conv_new = [];
//                 const list_conv_open = [];
//                 const list_conv_in_progress = [];
//                 const list_conv_pending = [];
//                 const list_conv_closed = [];

//                 let qtdReadNew = 0;
//                 let qtdReadOpen = 0;
//                 let qtdReadInProgress = 0;
//                 let qtdReadPending = 0;
//                 let qtdReadClosed = 0;

//                 for (var conv = 0; conv < response.data.conversations.length; conv++) {
//                     if (response.data.conversations[conv].state === 'new') {
//                         list_conv_new.push(response.data.conversations[conv]);
//                         if (response.data.conversations[conv].read === false) {
//                             qtdReadNew = qtdReadNew + 1;
//                         }
//                     } else if (response.data.conversations[conv].state === 'open') {
//                         list_conv_open.push(response.data.conversations[conv]);
//                         if (response.data.conversations[conv].read === false) {
//                             qtdReadOpen = qtdReadOpen + 1;
//                         }
//                     } else if (response.data.conversations[conv].state === 'in_progress') {
//                         list_conv_in_progress.push(response.data.conversations[conv]);
//                         if (response.data.conversations[conv].read === false) {
//                             qtdReadInProgress = qtdReadInProgress + 1;
//                         }
//                     } else if (response.data.conversations[conv].state === 'pending') {
//                         list_conv_pending.push(response.data.conversations[conv]);
//                         if (response.data.conversations[conv].read === false) {
//                             qtdReadPending = qtdReadPending + 1;
//                         }
//                     } else if (response.data.conversations[conv].state === 'closed') {
//                         list_conv_closed.push(response.data.conversations[conv]);
//                         if (response.data.conversations[conv].read === false) {
//                             qtdReadClosed = qtdReadClosed + 1;
//                         }
//                     }
//                 }

//                 //? Definindo quantidade de conversas que estao sem ler
//                 setQtdConvNew(qtdReadNew);
//                 setQtdConvOpen(qtdReadOpen);
//                 setQtdConvInProgress(qtdReadInProgress);
//                 setQtdConvPending(qtdReadPending);
//                 setQtdConvClosed(qtdReadClosed);

//                 //? Populando as listas de mensagens
//                 setConversationsNew(list_conv_new);
//                 setConversationsOpen(list_conv_open);
//                 setConversationsInprogress(list_conv_in_progress);
//                 setConversationsPending(list_conv_pending);
//                 setConversationsClosed(list_conv_closed);
//                 setStatus({ type: '', message: '' });
//             } else {
//                 setStatus({
//                     type: 'error',
//                     message: 'Erro ao listar conversas.3'
//                 });
//             }
//         } catch (error) {
//             console.error(error);
//             setStatus({
//                 type: 'error',
//                 message: 'Erro ao listar conversas.4'
//             });
//         }
//     };

//     const pegar_mensagens_conversa = async () => {
//         try {
//             console.log(`Mensagens da conversa ${selectedConversation.id}`);
//             if (selectedConversation) {
//                 const response = await api.get(`v1/apps/${appId}/conversations/${selectedConversation.id}/messages/`);
//                 if (response.data) {
//                     console.log(`Mensagens: ${JSON.stringify(response.data.messages.length)}`);
//                     setMessages(response.data.messages);
//                 } else {
//                     setStatus({
//                         type: 'error',
//                         message: 'Erro ao pegar as mensagens da conversa.'
//                     });
//                 }
//             }
//         } catch (error) {
//             console.error(error);
//             setStatus({
//                 type: 'error',
//                 message: 'Erro ao pegar as mensagens da conversa.'
//             });
//         }
//     };

//     const marcar_conversa_como_lida = async (conversation) => {
//         try {
//             // console.log(`marcar_conversa_como_lida: entrou`);
//             // console.log(`marcar_conversa_como_lida conversation: ${conversation}`);
//             if (!conversation) return;
//             const response = await api.patch(`v1/apps/${appId}/conversations/${conversation.id}/`, {
//                 read: true
//             });
//             if (response.data) {
//                 marcar_mensagens_como_lida(conversation);
//             } else {
//                 setStatus({
//                     type: 'error',
//                     message: 'Erro ao marcar conversa como lida'
//                 });
//             }
//         } catch (error) {
//             console.error(error);
//             setStatus({
//                 type: 'error',
//                 message: 'Erro ao marcar conversa como lida'
//             });
//         }
//     };

//     const marcar_mensagens_como_lida = async (conversation) => {
//         try {
//             console.log(`marcar_mensagens_como_lida: entrou`);

//             const response = await api.patch(`v1/apps/${appId}/conversations/${conversation.id}/messages/`, {
//                 read: true
//             });
//             if (response.data) {
//                 console.log('Erro ao marcar como lida.');
//             } else {
//                 setStatus({
//                     type: 'error',
//                     message: 'Erro ao marcar conversa como lida'
//                 });
//             }
//         } catch (error) {
//             console.error(error);
//             setStatus({
//                 type: 'error',
//                 message: 'Erro ao marcar conversa como lida'
//             });
//         }
//     };

//     const enviar_mensagens_conversa = async () => {
//         try {
//             console.log(`enviar_mensagens_conversa: ${inputMessage}`);

//             const response = await api.post(`v1/apps/${appId}/conversations/${selectedConversation.id}/messages/`, {
//                 author: {
//                     userId: '',
//                     avatarUrl: '',
//                     displayName: 'Nome Atendente',
//                     type: 'agent'
//                 },
//                 content: {
//                     type: 'text',
//                     text: inputMessage
//                 },
//                 source: {
//                     integrationId: '1',
//                     originalMessageId: '',
//                     originalMessageTimestamp: '',
//                     type: 'text'
//                 }
//             });
//             if (response.data) {
//                 setInputMessage('');
//             } else {
//                 setStatus({
//                     type: 'error',
//                     message: 'Erro ao enviar mensagem na conversa!'
//                 });
//             }
//         } catch (error) {
//             console.error(error);
//             setStatus({
//                 type: 'error',
//                 message: 'Erro ao enviar mensagem na conversa!'
//             });
//         }
//     };

//     const handleOpenConversation = (conversation, deal) => {
//         console.log(`handleOpenConversation - conversation:${JSON.stringify(conversation)}`);
//         console.log(`handleOpenConversation - deal:${JSON.stringify(deal)}`);

//         if (!conversation) {
//             setStatus({
//                 type: 'warning',
//                 message: 'Este negócio não possui conversa vinculada.'
//             });
//             return;
//         }

//         setSelectedDeal(deal);
//         setSelectedConversation(conversation);
//         setDrawerOpen(true);
//         marcar_conversa_como_lida(conversation);
//         setStatus({ type: '', message: '' });
//     };

//     const handleCloseDrawer = () => {
//         setDrawerOpen(false);
//         setSelectedConversation(null);
//         setStatus({ type: '', message: '' });
//     };

//     const handleChange = (e) => {
//         console.log(`handleChange: ${e.target}`);
//         const { name, value } = e.target;
//         setInputMessage(value);
//         console.log(`inputMessage: ${inputMessage}`);
//     };

//     //? TEMA DO INPUT MENSAGEM
//     const theme = useTheme();
//     const isDark = theme.palette.mode === 'dark';

//     const [showEmoji, setShowEmoji] = useState(false);

//     const handleKeyDown = (e) => {
//         if (e.key === 'Enter' && !e.shiftKey) {
//             e.preventDefault();
//             if (inputMessage.trim()) {
//                 enviar_mensagens_conversa();
//                 setInputMessage('');
//             }
//         }
//     };

//     //?------------- TABS PARA TROCAR LATERALMENTE -----------------------
//     const StyledTabs = styled((props) => <Tabs {...props} TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }} />)({
//         '& .MuiTabs-indicator': {
//             display: 'flex',
//             justifyContent: 'center',
//             backgroundColor: 'transparent'
//         },
//         '& .MuiTabs-indicatorSpan': {
//             maxWidth: 40,
//             width: '100%',
//             backgroundColor: '#635ee7'
//         }
//     });

//     const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
//         textTransform: 'none',
//         fontWeight: theme.typography.fontWeightRegular,
//         fontSize: theme.typography.pxToRem(15),
//         marginRight: theme.spacing(1),
//         color: 'rgba(0, 0, 0, 0.7)',
//         '&.Mui-selected': {
//             color: theme.palette.text.primary
//         }
//     }));

//     function TabPanel(props) {
//         const { children, value, index } = props;

//         return (
//             <div role="tabpanel" hidden={value !== index}>
//                 {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//             </div>
//         );
//     }

//     TabPanel.propTypes = {
//         children: PropTypes.node,
//         index: PropTypes.number.isRequired,
//         value: PropTypes.number.isRequired
//     };

//     function a11yProps(index) {
//         return {
//             id: `tab-${index}`,
//             'aria-controls': `tabpanel-${index}`
//         };
//     }
//     //?--------------- FIM TABS PARA TROCAR LATERALMENTE ------------------

//     //? -------------- FUNCOES NEGOCIO ------------------------
//     const pegar_negocios = async () => {
//         try {
//             if (!appId) return;
//             // console.log(`pegar_negocios - entrou`);

//             const response = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/deals/`);
//             if (response.data) {
//                 setNegocio(response.data);
//             } else {
//                 setStatus({
//                     type: 'error',
//                     message: 'Erro ao pegar negócios 1.'
//                 });
//                 setNegocio({});
//             }
//         } catch (error) {
//             console.error(`pegar_negocios error: ${JSON.stringify(error.data)}`);
//             setStatus({
//                 type: 'error',
//                 message: 'Erro ao pegar negócios 2.'
//             });
//             setNegocio({});
//         }
//     };

//     const fonteStyle1 = {
//         fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
//         fontSize: 15,
//         lineHeight: 0.8,
//         // color: 'black'
//         color: theme.palette.text.primary
//     };

//     const fonteStyle2 = {
//         fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
//         fontSize: 12,
//         lineHeight: 0.8,
//         color: theme.palette.text.primary
//     };

//     const fonteStyle3 = {
//         fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
//         fontSize: 10,
//         lineHeight: 0.1,
//         color: theme.palette.text.primary
//     };

//     useEffect(() => {
//         if (!localStorage.getItem('access_token')) return;
//         loadPipeline();
//     }, [appId]);

//     useEffect(() => {
//         if (!localStorage.getItem('access_token')) return;
//         pegar_negocios();
//     }, [appId, pipelines]);

//     async function loadPipeline() {
//         if (!appId) return;

//         const myHeaders = new Headers();
//         myHeaders.append('Content-Type', 'application/json');

//         try {
//             console.log('loadPipeline - entrou');
//             var stagesList;
//             const response = await api.get(`v1/apps/${appId}/pipelines/`);
//             if (!response.data) return;

//             if (response.data.length === 0) {
//                 setStatus({
//                     type: 'error',
//                     message: 'ERRO! NÃO EXISTEM PIPELINES CADASTRADAS! VÁ PARA "CONFIGURAÇÕES > NEGÓCIO" PARA CRIAR!'
//                 });
//                 return;
//             }

//             const dados = response.data;
//             var resPipelines = dados;
//             setPipelines(resPipelines);
//             let pipelineId = resPipelines[0].id;
//             setPipelineId(pipelineId);

//             // console.log(`loadPipeline - pipelineId:${pipelineId}`);

//             const myHeaders2 = new Headers();
//             myHeaders2.append('Content-Type', 'application/json');

//             const response3 = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/stages/`);

//             if (response3.data.length === 0) {
//                 setStatus({
//                     type: 'error',
//                     message: 'ERRO! NÃO EXISTEM STAGES CADASTRADAS! VÁ PARA "CONFIGURAÇÕES > NEGÓCIO > FASES" PARA CRIAR!'
//                 });
//                 return;
//             }

//             const dados3 = response3.data;

//             var resStages = dados3;

//             // console.log(`loadPipeline - resStages:${resStages}`);

//             stagesList = resStages;
//             if (!stagesList) {
//                 stagesList = [];
//             }

//             // console.log(`loadPipeline - stagesList:${stagesList}`);
//             setStages(stagesList);

//             const myHeaders4 = new Headers();
//             myHeaders4.append('Content-Type', 'application/json');
//             const response4 = await api.get(`v1/apps/${appId}/pipelines/${pipelineId}/deals/`);
//             if (!response4.data) return;

//             if (response4.data.length === 0) {
//                 // setStatus({
//                 //     type: 'error',
//                 //     message: 'Ainda não existem negócios criados!'
//                 // });
//             }

//             // console.log(`loadPipeline - response4.data:${JSON.stringify(response4.data)}`);
//             const dados4 = response4.data;
//             // console.log('loadPipeline - dados4:', dados4);

//             var resDeals = dados4;
//             const deals = resDeals;

//             // console.log(`loadPipeline - deals:${deals}`);

//             // const map = {};
//             // stagesList.forEach((s) => (map[s.id] = []));
//             const map = {};
//             stagesList.forEach((s) => (map[String(s.id)] = []));
//             if (!deals) return;
//             deals.forEach((d) => {
//                 // const sid = d.stage || (stagesList[0] && stagesList[0].id);
//                 // if (!map[sid]) map[sid] = [];
//                 // map[sid].push(d);
//                 const sid = String(d.stage || (stagesList[0] && stagesList[0].id));
//                 if (!map[sid]) map[sid] = [];
//                 map[sid].push(d);
//             });

//             // ordenar localmente por order
//             Object.keys(map).forEach((k) => map[k].sort((a, b) => a.ordering - b.ordering));

//             // console.log(`dealsByStage 1: ${JSON.stringify(map)}`);
//             setDealsByStage(map);
//             // console.log(`dealsByStage 2: ${JSON.stringify(dealsByStage)}`);
//         } catch (err) {
//             setStatus({
//                 type: 'error',
//                 message: 'ERRO AO CONSULTAR NEGÓCIOS'
//             });
//         }
//     }

//     const onDragEnd = async (result) => {
//         const { destination, source, draggableId } = result;
//         if (!destination) return;

//         // const fromStage = parseInt(source.droppableId);
//         // const toStage = parseInt(destination.droppableId);
//         const fromStage = source.droppableId;
//         const toStage = destination.droppableId;

//         // Se nada mudou, não faz nada
//         if (fromStage === toStage && source.index === destination.index) {
//             return;
//         }

//         let newMap = { ...dealsByStage };

//         console.log('fromStage:', fromStage);
//         console.log('toStage:', toStage);
//         console.log('newMap:', newMap);

//         // Movendo DENTRO da mesma coluna
//         if (fromStage === toStage) {
//             const items = Array.from(newMap[fromStage]);
//             const [moved] = items.splice(source.index, 1);
//             if (!moved) return;
//             items.splice(destination.index, 0, moved);

//             newMap[fromStage] = items;
//         }
//         // Movendo ENTRE colunas
//         else {
//             // const sourceItems = Array.from(newMap[fromStage]);
//             // const destItems = Array.from(newMap[toStage]);
//             const sourceItems = Array.from(newMap[fromStage] || []);
//             const destItems = Array.from(newMap[toStage] || []);
//             const [moved] = sourceItems.splice(source.index, 1);
//             if (!moved) return;

//             moved.stage = toStage; // atualiza stage localmente

//             destItems.splice(destination.index, 0, moved);

//             newMap[fromStage] = sourceItems;
//             newMap[toStage] = destItems;
//         }

//         // console.log(`setDealsByStage newMap: ${JSON.stringify(newMap)}`);
//         setDealsByStage(newMap);

//         // envia o payload ao backend
//         const payload = [];
//         Object.keys(newMap).forEach((stageId) => {
//             newMap[stageId].forEach((d, idx) => {
//                 payload.push({
//                     id: d.id,
//                     // stage: parseInt(stageId),
//                     stage: stageId,
//                     ordering: idx
//                 });
//             });
//         });

//         try {
//             const myHeaders5 = new Headers();
//             myHeaders5.append('Content-Type', 'application/json');
//             const response5 = await api.post(`v1/apps/${appId}/deals/reorder/`, payload);
//             if (response5.data) {
//                 const dados5 = response5.data;
//                 // console.log('onDrag - dados5:', dados5);
//             } else {
//                 setStatus({
//                     type: 'error',
//                     message: 'Erro ao reordenar Negócios!'
//                 });
//             }
//         } catch (err) {
//             console.error(err);
//             loadPipeline();
//             setStatus({
//                 type: 'error',
//                 message: 'Erro ao reordenar Negócios!'
//             });
//         }
//     };

//     // console.log(`setDealsByStage dealsByStage: ${JSON.stringify(dealsByStage)}`);
//     return (
//         <Box>
//             {/* <Typography variant="h2">Olá, {user?.first_name || user?.email}</Typography> */}

//             <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mt: 3 }}>
//                 <Typography variant="h3" gutterBottom sx={{ mb: 0 }}>
//                     Leads
//                 </Typography>

//                 <Button
//                     variant="contained"
//                     onClick={() => setOpenNewDealDrawer(true)}
//                     disabled={!pipelineId || !stages?.length}
//                     sx={{ backgroundColor: '#32CD32', textTransform: 'none' }}
//                 >
//                     Criar Negócio
//                 </Button>
//             </Box>

//             {status.message && (
//                 <Alert severity={status.type} sx={{ mb: 2 }}>
//                     {status.message}
//                 </Alert>
//             )}

//             <Box
//                 sx={{
//                     display: 'flex',
//                     gap: 1,
//                     p: 1,
//                     mt: 1,
//                     width: '100%',
//                     height: '100%',
//                     overflowX: 'auto',
//                     flexWrap: 'nowrap'
//                 }}
//             >
//                 <DragDropContext onDragEnd={onDragEnd}>
//                     {stages.map((stage) => (
//                         <Droppable droppableId={`${stage.id}`} key={stage.id}>
//                             {(provided) => (
//                                 <Box
//                                     ref={provided.innerRef}
//                                     {...provided.droppableProps}
//                                     sx={{
//                                         flex: '1 1 260px',
//                                         minWidth: 260,
//                                         maxWidth: 340,
//                                         display: 'flex',
//                                         flexDirection: 'column'
//                                     }}
//                                 >
//                                     <Box mb={1} display="flex" justifyContent="flex" alignItems="center">
//                                         <Typography
//                                             variant="body2"
//                                             color="text.primary"
//                                             justifyContent="center"
//                                             marginLeft={14}
//                                             style={fonteStyle1}
//                                         >
//                                             {stage.name}
//                                         </Typography>
//                                     </Box>
//                                     <Box mb={1} display="flex" justifyContent="flex" alignItems="center">
//                                         {(() => {
//                                             const total = (dealsByStage[stage.id] || []).reduce(
//                                                 (acc, deal) => acc + parseFloat(deal.value || 0),
//                                                 0
//                                             );

//                                             return (
//                                                 <>
//                                                     <Typography
//                                                         variant="5px"
//                                                         color="text.primary"
//                                                         justifyContent="center"
//                                                         marginLeft={15}
//                                                         style={fonteStyle2}
//                                                     >
//                                                         R${total.toFixed(2)}
//                                                     </Typography>
//                                                 </>
//                                             );
//                                         })()}
//                                     </Box>
//                                     <Box>
//                                         <Typography
//                                             variant="5px"
//                                             color="text.primary"
//                                             justifyContent="center"
//                                             marginLeft={15}
//                                             style={fonteStyle3}
//                                         >
//                                             {(dealsByStage[stage.id] || []).length}{' '}
//                                             {(dealsByStage[stage.id] || []).length > 1 ? 'negócios' : 'negócio'}
//                                         </Typography>
//                                     </Box>

//                                     <Card
//                                         variant="outlined"
//                                         sx={{
//                                             width: '100%',
//                                             height: 'calc(100vh - 220px)', // altura baseada na tela
//                                             background: classes.conversationBar, //'#E8E9EB', //0A1828 //262525 //E8E9EB //CBCFD6
//                                             display: 'flex',
//                                             flexDirection: 'column'
//                                         }}
//                                     >
//                                         <CardContent
//                                             sx={{
//                                                 flex: 1,
//                                                 overflowY: 'auto', // scroll só quando tiver muitos cards
//                                                 overflowX: 'hidden',
//                                                 p: 1
//                                             }}
//                                         >
//                                             {(dealsByStage[stage.id] || []).map((deal, index) => (
//                                                 <Draggable draggableId={`${deal.id}`} index={index} key={deal.id}>
//                                                     {(provided2, snapshot) => (
//                                                         <div
//                                                             ref={provided2.innerRef}
//                                                             {...provided2.draggableProps}
//                                                             {...provided2.dragHandleProps}
//                                                             style={{
//                                                                 userSelect: 'none',
//                                                                 marginBottom: 0,
//                                                                 marginLeft: 0,
//                                                                 marginRight: 0,
//                                                                 ...provided2.draggableProps.style
//                                                             }}
//                                                         >
//                                                             {deal.conversation && (
//                                                                 <DealConversationCard
//                                                                     deal={deal}
//                                                                     onClick={() => handleOpenConversation(deal.conversation_detail, deal)}
//                                                                 />
//                                                             )}
//                                                             {!deal.conversation && (
//                                                                 <DealCard deal={deal} onClick={() => setOpenDealDrawer(true)} />
//                                                             )}
//                                                         </div>
//                                                     )}
//                                                 </Draggable>
//                                             ))}
//                                             {provided.placeholder}
//                                         </CardContent>
//                                     </Card>
//                                 </Box>
//                             )}
//                         </Droppable>
//                     ))}
//                 </DragDropContext>
//             </Box>
//             {/* Drawer conversa selecionada */}
//             <JanelaConversa
//                 status_drawer={drawerOpen}
//                 onCloseDrawer={handleCloseDrawer}
//                 conversa_selecionada={selectedConversation}
//                 mensagens={messages}
//                 appId={appId}
//                 conversa_lida={marcar_conversa_como_lida}
//                 deal={selectedDeal}
//                 pipelineId={pipelineId}
//             />

//             <Drawer
//                 anchor="right"
//                 open={openNewDealDrawer}
//                 onClose={() => setOpenNewDealDrawer(false)}
//                 PaperProps={{ sx: { width: '40vw', p: 2 } }}
//             >
//                 {openNewDealDrawer && (
//                     <NewDeal
//                         pipelineId={pipelineId}
//                         firstStageId={stages[0]?.id || null}
//                         onClose={() => setOpenNewDealDrawer(false)}
//                         onSaved={loadPipeline}
//                     />
//                 )}
//             </Drawer>

//             <Drawer anchor="right" open={openDealDrawer} onClose={closeDealDrawer} PaperProps={{ sx: { width: '40vw', p: 2 } }}>
//                 {selectedDeal && (
//                     <DealDrawer deal={selectedDeal} onClose={closeDealDrawer} onSaved={loadPipeline} pipelineId={pipelineId} />
//                 )}
//             </Drawer>
//         </Box>
//     );
// };

// export default PipelineMain;

import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
    Alert,
    Box,
    Grid,
    Button,
    MenuItem,
    TextField,
    Card,
    CardContent,
    Drawer,
    Typography,
    Chip,
    Checkbox,
    FormControlLabel,
    Collapse,
    IconButton,
    Badge,
    Menu
} from '@mui/material';
import { IconFilter, IconFilterOff, IconUsers } from '@tabler/icons';
import api from '../../services/api';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DealConversationCard from '../authentication/conversas/DealConversationCard';
import DealCard from '../authentication/conversas/DealCard';
import JanelaConversa from '../../pages/authentication/conversas/JanelaConversa';
import NewDeal from './NewDeal';
import DealDrawer from './DealDrawer';
import { makeStyles } from '@mui/styles';
import useTheme from '@mui/material/styles/useTheme';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex'
    },
    appBar: {
        backgroundColor: '#0A1828',
        zIndex: theme.zIndex.drawer + 1,
        height: 48,
        transition: theme.transitions.create(['top'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    conversationBar: {
        background: 'transparent',
        color: '#e60000'
    },
    toolbar: {
        minHeight: 48
    },
    appBarWidth: {
        transition: theme.transitions.create('width'),
        backgroundColor: theme.palette.background.default
    },
    content: {
        ...theme.typography.mainContent,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px',
            padding: '16px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            padding: '16px',
            marginRight: '10px'
        }
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    }
}));

const StyledTabs = styled((props) => <Tabs {...props} TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }} />)({
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent'
    },
    '& .MuiTabs-indicatorSpan': {
        maxWidth: 40,
        width: '100%',
        backgroundColor: '#7be9ff',
        boxShadow: '0 0 14px rgba(123,233,255,0.4)'
    }
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: 'rgba(255,255,255,0.60)',
    '&.Mui-selected': {
        color: 'rgba(255,255,255,0.95)'
    }
}));

function TabPanel(props) {
    const { children, value, index } = props;

    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
};

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`
    };
}

const getBoardContainerSx = (isDark) => ({
    position: 'relative',
    mt: 2,
    p: 2,
    borderRadius: '30px',
    overflow: 'hidden',
    border: isDark ? '1px solid rgba(108,220,255,0.16)' : '1px solid rgba(0,130,220,0.18)',
    background: isDark
        ? `
        radial-gradient(circle at 50% 0%, rgba(0,180,255,0.10), transparent 20%),
        radial-gradient(circle at 15% 100%, rgba(0,140,255,0.08), transparent 18%),
        linear-gradient(180deg, rgba(5,12,22,0.95) 0%, rgba(3,7,14,0.98) 100%)
    `
        : `
        radial-gradient(circle at 50% 0%, rgba(0,150,255,0.08), transparent 20%),
        radial-gradient(circle at 15% 100%, rgba(0,120,255,0.06), transparent 18%),
        linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(233,246,255,0.96) 100%)
    `,
    boxShadow: isDark
        ? '0 0 50px rgba(0,170,255,0.08), inset 0 0 70px rgba(43,170,255,0.035), inset 0 1px 0 rgba(255,255,255,0.04)'
        : '0 0 30px rgba(0,140,255,0.10), inset 0 0 40px rgba(0,140,255,0.03), inset 0 1px 0 rgba(255,255,255,0.7)'
});

const getHeaderButtonSx = (isDark) => ({
    borderRadius: '16px',
    textTransform: 'none',
    px: 2.2,
    py: 1.1,
    fontWeight: 500,
    color: isDark ? '#03111c' : '#04283d',
    border: isDark ? '1px solid rgba(120,220,255,0.18)' : '1px solid rgba(0,130,220,0.22)',
    background: isDark
        ? 'linear-gradient(180deg, rgba(115,229,255,0.96), rgba(58,162,214,0.95))'
        : 'linear-gradient(180deg, rgba(150,225,255,0.95), rgba(90,190,235,0.95))',
    boxShadow: isDark ? '0 0 24px rgba(89,214,255,0.20)' : '0 0 16px rgba(0,150,220,0.20)',
    '&:hover': {
        background: isDark
            ? 'linear-gradient(180deg, rgba(141,235,255,1), rgba(74,181,234,1))'
            : 'linear-gradient(180deg, rgba(170,235,255,1), rgba(105,205,245,1))',
        boxShadow: isDark ? '0 0 28px rgba(89,214,255,0.30)' : '0 0 20px rgba(0,150,220,0.28)'
    }
});

const getFilterPanelSx = (isDark) => ({
    mt: 2,
    p: 2.5,
    borderRadius: '24px',
    border: isDark ? '1px solid rgba(110,220,255,0.14)' : '1px solid rgba(0,120,220,0.16)',
    background: isDark
        ? 'linear-gradient(180deg, rgba(10,20,33,0.92), rgba(5,10,18,0.96))'
        : 'linear-gradient(180deg, rgba(255,255,255,0.92), rgba(232,244,255,0.85))',
    backdropFilter: 'blur(14px)',
    boxShadow: isDark ? 'inset 0 0 25px rgba(95,220,255,0.03)' : 'inset 0 0 18px rgba(0,140,255,0.03)'
});

const getFilterFieldSx = (isDark) => ({
    '& .MuiOutlinedInput-root': {
        borderRadius: '14px',
        color: isDark ? '#fff' : 'rgba(8,35,60,0.92)',
        background: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(255,255,255,0.85)',
        '& fieldset': {
            borderColor: isDark ? 'rgba(110,220,255,0.15)' : 'rgba(0,120,220,0.18)'
        },
        '&:hover fieldset': {
            borderColor: isDark ? 'rgba(110,220,255,0.35)' : 'rgba(0,120,220,0.35)'
        },
        '&.Mui-focused fieldset': {
            borderColor: isDark ? '#6edcff' : '#0091ea'
        }
    },
    '& .MuiInputLabel-root': {
        color: isDark ? 'rgba(255,255,255,0.55)' : 'rgba(8,35,60,0.55)'
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: isDark ? '#7be9ff' : '#0091ea'
    }
});

const CANAIS_MENSAGEM = [
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'messenger', label: 'Messenger' },
    { value: 'chat_web', label: 'Chat Web' },
    { value: 'voice', label: 'Voz' },
    { value: 'email', label: 'E-mail' },
    { value: 'agent_workspace', label: 'Agente' },
    { value: 'custom', label: 'Customizada' }
];

const TEMPERATURAS = [
    { value: 'quente', label: '🔥 Quente' },
    { value: 'morno', label: '☁️ Morno' },
    { value: 'frio', label: '❄️ Frio' }
];

const FILTROS_INICIAIS = {
    assign: '',
    apenasMeus: false,
    canal: '',
    dataInicio: '',
    dataFim: '',
    temperaturas: [],
    valorMin: '',
    valorMax: '',
    semValor: false,
    contatoCanal: '',
    nomeCliente: '',
    nomeOrganizacao: ''
};

// Quantos negócios carregar por coluna de cada vez - com muitos negócios
// numa etapa, renderizar tudo de uma vez deixava a tela pesada; agora cada
// coluna carrega essa quantidade e tem um botão "Carregar mais".
const PAGE_SIZE = 30;

const PipelineMain = () => {
    const user = useSelector((state) => state.account.user);
    // const account = useSelector((state) => state.account);
    const role_user = useSelector((state) => state.account.user?.role || '');
    const classes = useStyles();
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [status, setStatus] = useState({ type: '', message: '' });

    const [pipelines, setPipelines] = useState([]);
    // const [pipelineId, setPipelineId] = useState(null);
    const [stages, setStages] = useState([]);
    const [dealsByStage, setDealsByStage] = useState({});
    // { [stageId]: { total, loadingMore } } - quantos negócios existem no
    // total naquela etapa (pro botão "Carregar mais") e se um "carregar
    // mais" está em andamento pra essa coluna.
    const [dealsMeta, setDealsMeta] = useState({});
    // Ref (não state) porque `loadDeals` roda dentro de um setInterval cujo
    // closure foi capturado na hora que o efeito rodou - um state comum
    // ficaria desatualizado ali; a ref sempre reflete o valor mais recente.
    const dealsLoadedCountRef = useRef({});
    // Sempre reflete o pipeline selecionado NO MOMENTO - usado por `loadDeals`
    // pra descartar respostas de um `loadDeals()` antigo que ainda estava em
    // voo quando o usuário trocou de pipeline (ou de um polling que ficou
    // "preso" no pipeline anterior). Sem isso, uma resposta atrasada do
    // pipeline errado sobrescrevia a tela com os dados (vazios) do pipeline
    // de antes, alguns segundos depois de trocar - os negócios apareciam e
    // "somiam" sozinhos.
    const pipelineIdRef = useRef(null);
    // `loadDeals`/`pegar_conversas` são funções normais, recriadas a cada
    // render (fecham sobre `stagesList`/`wizardData` da vez) - o
    // setInterval abaixo só é criado UMA vez (não recria quando só
    // `stagesList` muda, sem trocar de pipeline) e guardava pra sempre a
    // versão de `loadDeals` capturada naquele momento. Se os estágios do
    // pipeline mudassem depois (edição, novo estágio), o polling continuava
    // buscando pela lista de estágios ANTIGA pra sempre - por isso os
    // negócios apareciam certos (carregamento direto, com a lista nova) e
    // sumiam alguns segundos depois (o polling reaplicando a lista velha,
    // vazia). As refs abaixo são atualizadas a cada render e o interval
    // chama sempre a versão mais recente através delas.
    const loadDealsRef = useRef(() => {});
    const pegarConversasRef = useRef(() => {});
    // LOG TEMPORÁRIO - investigação "pipeline carrega e depois some": id
    // único por instância montada desse componente. Se aparecer mais de um
    // `instanceId` diferente no console ao mesmo tempo, é porque existe mais
    // de um `PipelineMain` montado simultaneamente (ex: um embutido no
    // Dashboard + a tela dedicada de Negócios) - não é o mesmo estado
    // "piscando", são duas instâncias competindo.
    const instanceIdRef = useRef(Math.random().toString(36).slice(2, 8));
    useEffect(() => {
        const instance = instanceIdRef.current;
        console.log('[DIAG] PipelineMain - MONTOU', { instance, url: window.location.pathname });
        return () => console.log('[DIAG] PipelineMain - DESMONTOU', { instance, url: window.location.pathname });
    }, []);
    const [selectedDeal, setSelectedDeal] = useState(null);
    const [openDealDrawer, setOpenDealDrawer] = useState(false);
    const [openNewDealDrawer, setOpenNewDealDrawer] = useState(false);

    const [listaPipelines, setListaPipelines] = useState([]);

    const [stagesList, setStagesList] = useState([]);

    const [appId, setAppId] = useState();

    const [conversationsNew, setConversationsNew] = useState([]);
    const [conversationsOpen, setConversationsOpen] = useState([]);
    const [conversationsInProgress, setConversationsInprogress] = useState([]);
    const [conversationsPending, setConversationsPending] = useState([]);
    const [conversationsClosed, setConversationsClosed] = useState([]);
    const [selectedConversation, setSelectedConversation] = useState(null);

    const [qtdConvNew, setQtdConvNew] = useState(0);
    const [qtdConvOpen, setQtdConvOpen] = useState(0);
    const [qtdConvInProgress, setQtdConvInProgress] = useState(0);
    const [qtdConvPending, setQtdConvPending] = useState(0);
    const [qtdConvClosed, setQtdConvClosed] = useState(0);

    const [messages, setMessages] = useState([]);
    // `message_list_create` (GET) agora só traz a janela mais recente por
    // padrão (ver backend) - esses dois controlam o botão "Carregar
    // mensagens anteriores" que busca mais história sob demanda (mesmo
    // padrão de `Chats3.js`).
    const [hasMoreOlderMessages, setHasMoreOlderMessages] = useState(false);
    const [loadingOlderMessages, setLoadingOlderMessages] = useState(false);
    const [inputMessage, setInputMessage] = useState('');
    const [value, setValue] = React.useState(0);
    const [value2, setValue2] = React.useState(0);
    const [wizardData, setWizardData] = React.useState({
        pipeline: {
            name: '',
            id: ''
        }
    });

    const podeFiltrarPorQualquerAtribuido = role_user === 'admin' || role_user === 'manager';

    const [showFilters, setShowFilters] = useState(false);
    const [teamUsers, setTeamUsers] = useState([]);
    const [filtros, setFiltros] = useState(FILTROS_INICIAIS);

    // Botão "Equipes" ao lado de "Filtros" - mesmo mecanismo de
    // `Chats3.js`: lista as equipes (admin vê todas, os demais só a(s)
    // própria(s) - o próprio endpoint `teams/` já restringe isso) e manda
    // a escolhida pro backend via `?team=` na busca de negócios
    // (`loadDeals`), que aplica o mesmo filtro/restrição por equipe já
    // usado em Conversas.
    const [equipesFiltro, setEquipesFiltro] = useState([]);
    const [selectedTeamFilter, setSelectedTeamFilter] = useState('');
    const [teamMenuAnchor, setTeamMenuAnchor] = useState(null);

    const loadEquipesFiltro = async () => {
        if (!appId) return;
        try {
            const response = await api.get(`v1/apps/${appId}/teams/`);
            setEquipesFiltro(response.data?.teams || []);
        } catch (error) {
            console.error('Erro ao carregar equipes', error);
        }
    };

    const handleSelectTeamFilter = (teamId) => {
        setSelectedTeamFilter(teamId || '');
        setTeamMenuAnchor(null);
    };

    useEffect(() => {
        loadEquipesFiltro();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId]);

    useEffect(() => {
        if (!podeFiltrarPorQualquerAtribuido) return;

        const carregarUsuarios = async () => {
            try {
                const response = await api.get('users/');
                setTeamUsers(response.data?.users || response.data || []);
            } catch (error) {
                console.error(error);
            }
        };

        carregarUsuarios();
    }, [podeFiltrarPorQualquerAtribuido]);

    const toggleTemperatura = (temp) => {
        setFiltros((prev) => ({
            ...prev,
            temperaturas: prev.temperaturas.includes(temp)
                ? prev.temperaturas.filter((t) => t !== temp)
                : [...prev.temperaturas, temp]
        }));
    };

    const limparFiltros = () => setFiltros(FILTROS_INICIAIS);

    const filtrosAtivosCount = Object.entries(filtros).filter(([chave, valor]) => {
        if (chave === 'temperaturas') return valor.length > 0;
        if (typeof valor === 'boolean') return valor;
        return valor !== '';
    }).length;

    const dealPassaNosFiltros = (deal) => {
        if (podeFiltrarPorQualquerAtribuido) {
            if (filtros.assign && String(deal.assign || '') !== String(filtros.assign)) return false;
        } else if (filtros.apenasMeus) {
            const isMine = String(deal.assign || '') === String(user?.id || '');
            const isUnassigned = !deal.assign;
            if (!isMine && !isUnassigned) return false;
        }

        if (filtros.canal && deal.conversation_detail?.type !== filtros.canal) return false;

        if (filtros.dataInicio) {
            const inicio = new Date(`${filtros.dataInicio}T00:00:00`);
            if (!deal.created_at || new Date(deal.created_at) < inicio) return false;
        }

        if (filtros.dataFim) {
            const fim = new Date(`${filtros.dataFim}T23:59:59`);
            if (!deal.created_at || new Date(deal.created_at) > fim) return false;
        }

        if (filtros.temperaturas.length > 0 && !filtros.temperaturas.includes(deal.status)) return false;

        const valorDeal = parseFloat(deal.value || 0);

        if (filtros.semValor) {
            if (valorDeal !== 0) return false;
        } else {
            if (filtros.valorMin !== '' && valorDeal < parseFloat(filtros.valorMin)) return false;
            if (filtros.valorMax !== '' && valorDeal > parseFloat(filtros.valorMax)) return false;
        }

        if (filtros.contatoCanal) {
            const nomeContato = (deal.conversation_detail?.displayName || '').toLowerCase();
            if (!nomeContato.includes(filtros.contatoCanal.toLowerCase())) return false;
        }

        if (filtros.nomeCliente) {
            const nomeCliente = `${deal.user_detail?.first_name || ''} ${deal.user_detail?.last_name || ''}`.toLowerCase();
            if (!nomeCliente.includes(filtros.nomeCliente.toLowerCase())) return false;
        }

        if (filtros.nomeOrganizacao) {
            const nomeOrg = (deal.organization_detail?.name || '').toLowerCase();
            if (!nomeOrg.includes(filtros.nomeOrganizacao.toLowerCase())) return false;
        }

        return true;
    };

    const getDealsFiltrados = (stageId) => (dealsByStage[String(stageId)] || []).filter(dealPassaNosFiltros);

    // Removido um useEffect(() => loadPipeline(), []) redundante aqui - com
    // deps vazias ele sempre rodava antes de `appId` existir (loadPipeline
    // já retorna cedo sem appId), então nunca fazia nada; o carregamento
    // real acontece no effect abaixo que depende de `appId`.
    useEffect(() => {
        if (!wizardData.pipeline.id) return;

        // carregarDadosDoFunil(wizardData.pipeline.id);
    }, [wizardData.pipeline.id]);

    useEffect(() => {
        pipelineIdRef.current = wizardData.pipeline.id || null;
    }, [wizardData.pipeline.id]);

    const pegar_app_padrao = async () => {
        try {
            const response = await api.get('v1/apps/default/');
            const data = response.data;
            setAppId(data.app.id);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (!localStorage.getItem('access_token')) return;
        pegar_app_padrao();
    }, []);

    useEffect(() => {
        if (!localStorage.getItem('access_token')) return;
        if (!appId) return;
        pegar_conversas();
        loadPipeline();
    }, [appId]);

    // Mantém as refs sempre com a versão mais recente de `loadDeals`/
    // `pegar_conversas` (fecham sobre `stagesList`/`wizardData` do render
    // atual) - roda em TODO render, sem array de dependências, de propósito.
    useEffect(() => {
        loadDealsRef.current = loadDeals;
        pegarConversasRef.current = pegar_conversas;
    });

    useEffect(() => {
        if (!localStorage.getItem('access_token')) return;
        if (!appId) return;
        if (!wizardData.pipeline.id) return;

        const interval = setInterval(() => {
            pegarConversasRef.current();
            loadDealsRef.current();
        }, 5000);

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId, wizardData.pipeline.id]);

    useEffect(() => {
        if (!localStorage.getItem('access_token')) return;
        if (!selectedConversation || !appId) return;

        setHasMoreOlderMessages(false);
        pegar_mensagens_conversa();

        const interval = setInterval(() => {
            // `merge: true` - ver `mergeIncomingMessages` acima (mesmo
            // motivo de `Chats3.js`: não apagar páginas mais antigas já
            // carregadas via "Carregar mensagens anteriores").
            pegar_mensagens_conversa({ merge: true });
        }, 3000);

        return () => clearInterval(interval);
    }, [selectedConversation?.id, appId]);

    // Removido um segundo useEffect(() => loadPipeline(), [appId]) aqui -
    // era idêntico ao que já roda lá em cima (pegar_conversas() +
    // loadPipeline() quando appId muda), disparando GET .../pipelines/ 2x
    // à toa em todo carregamento da tela.

    // useEffect(() => {
    //     if (!localStorage.getItem('access_token')) return;
    //     if (!appId || !wizardData.pipeline.id) return;
    //     loadDeals();
    // }, [appId, pipelines, wizardData.pipeline.id]);

    useEffect(() => {
        if (!appId) return;
        if (!wizardData.pipeline.id) return;

        // carregarPipelineSelecionada();
    }, [appId, wizardData.pipeline.id]);

    useEffect(() => {
        if (!appId) return;
        if (!wizardData.pipeline.id) return;

        loadStages();
    }, [appId, wizardData.pipeline.id]);

    useEffect(() => {
        if (!appId) return;
        if (!wizardData.pipeline.id) return;
        if (!stagesList.length) return;

        loadDeals();
    }, [appId, wizardData.pipeline.id, stagesList, selectedTeamFilter]);

    const pegar_conversas = async () => {
        if (!appId) return;

        try {
            const response = await api.get(`v1/apps/${appId}/conversations/`);
            if (response.data) {
                const list_conv_new = [];
                const list_conv_open = [];
                const list_conv_in_progress = [];
                const list_conv_pending = [];
                const list_conv_closed = [];

                let qtdReadNew = 0;
                let qtdReadOpen = 0;
                let qtdReadInProgress = 0;
                let qtdReadPending = 0;
                let qtdReadClosed = 0;

                for (let conv = 0; conv < response.data.conversations.length; conv++) {
                    const current = response.data.conversations[conv];

                    if (current.state === 'new') {
                        list_conv_new.push(current);
                        if (current.read === false) qtdReadNew += 1;
                    } else if (current.state === 'open') {
                        list_conv_open.push(current);
                        if (current.read === false) qtdReadOpen += 1;
                    } else if (current.state === 'in_progress') {
                        list_conv_in_progress.push(current);
                        if (current.read === false) qtdReadInProgress += 1;
                    } else if (current.state === 'pending') {
                        list_conv_pending.push(current);
                        if (current.read === false) qtdReadPending += 1;
                    } else if (current.state === 'closed') {
                        list_conv_closed.push(current);
                        if (current.read === false) qtdReadClosed += 1;
                    }
                }

                setQtdConvNew(qtdReadNew);
                setQtdConvOpen(qtdReadOpen);
                setQtdConvInProgress(qtdReadInProgress);
                setQtdConvPending(qtdReadPending);
                setQtdConvClosed(qtdReadClosed);

                setConversationsNew(list_conv_new);
                setConversationsOpen(list_conv_open);
                setConversationsInprogress(list_conv_in_progress);
                setConversationsPending(list_conv_pending);
                setConversationsClosed(list_conv_closed);
                setStatus({ type: '', message: '' });
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao listar conversas.'
                });
            }
        } catch (error) {
            console.error(error);
            setStatus({
                type: 'error',
                message: 'Erro ao listar conversas.'
            });
        }
    };

    // Mescla a janela mais recente (`incoming`, sempre em ordem crescente)
    // nas mensagens já carregadas - sem isso, o poll de 3s (que só busca a
    // janela mais recente desde a paginação no backend) apagaria qualquer
    // página mais antiga já trazida via "Carregar mensagens anteriores".
    const mergeIncomingMessages = (prevMessages, incoming) => {
        if (prevMessages.length === 0) return incoming;
        const incomingById = new Map(incoming.map((m) => [m.id, m]));
        const mescladas = prevMessages.map((m) => incomingById.get(m.id) || m);
        const idsExistentes = new Set(prevMessages.map((m) => m.id));
        const novas = incoming.filter((m) => !idsExistentes.has(m.id));
        return [...mescladas, ...novas];
    };

    const pegar_mensagens_conversa = async ({ merge = false } = {}) => {
        try {
            if (selectedConversation) {
                const response = await api.get(`v1/apps/${appId}/conversations/${selectedConversation.id}/messages/`);

                if (response.data) {
                    if (merge) {
                        setMessages((prev) => mergeIncomingMessages(prev, response.data.messages));
                    } else {
                        setMessages(response.data.messages);
                        setHasMoreOlderMessages(Boolean(response.data.has_more_older));
                    }
                } else {
                    // setStatus({
                    //     type: 'error',
                    //     message: 'Erro ao pegar as mensagens da conversa.'
                    // });
                    console.log('Erro ao pegar as mensagens da conversa.');
                }
            }
        } catch (error) {
            console.error(error);
            // setStatus({
            //     type: 'error',
            //     message: 'Erro ao pegar as mensagens da conversa.'
            // });
            console.log('Erro ao pegar as mensagens da conversa.');
        }
    };

    const loadOlderMessages = async () => {
        if (!appId || !selectedConversation || messages.length === 0 || loadingOlderMessages) return;
        setLoadingOlderMessages(true);
        try {
            const maisAntigaCarregadaId = messages[0].id;
            const response = await api.get(
                `v1/apps/${appId}/conversations/${selectedConversation.id}/messages/?before_id=${maisAntigaCarregadaId}`
            );
            if (response.data) {
                setMessages((prev) => [...response.data.messages, ...prev]);
                setHasMoreOlderMessages(Boolean(response.data.has_more_older));
            }
        } catch (error) {
            console.error('Erro ao carregar mensagens anteriores', error);
        } finally {
            setLoadingOlderMessages(false);
        }
    };

    const marcar_conversa_como_lida = async (conversation) => {
        try {
            if (!conversation) return;

            const response = await api.patch(`v1/apps/${appId}/conversations/${conversation.id}/`, { read: true });

            if (response.data) {
                marcar_mensagens_como_lida(conversation);
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao marcar conversa como lida'
                });
            }
        } catch (error) {
            console.error(error);
            setStatus({
                type: 'error',
                message: 'Erro ao marcar conversa como lida'
            });
        }
    };

    const marcar_mensagens_como_lida = async (conversation) => {
        try {
            const response = await api.patch(`v1/apps/${appId}/conversations/${conversation.id}/messages/`, { read: true });

            if (!response.data) {
                setStatus({
                    type: 'error',
                    message: 'Erro ao marcar mensagens como lidas'
                });
            }
        } catch (error) {
            console.error(error);
            setStatus({
                type: 'error',
                message: 'Erro ao marcar conversa como lida'
            });
        }
    };

    const enviar_mensagens_conversa = async () => {
        try {
            const response = await api.post(`v1/apps/${appId}/conversations/${selectedConversation.id}/messages/`, {
                author: {
                    userId: '',
                    avatarUrl: '',
                    displayName: 'Nome Atendente',
                    type: 'agent'
                },
                content: {
                    type: 'text',
                    text: inputMessage
                },
                source: {
                    integrationId: '1',
                    originalMessageId: '',
                    originalMessageTimestamp: '',
                    type: 'text'
                }
            });

            if (response.data) {
                setInputMessage('');
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao enviar mensagem na conversa!'
                });
            }
        } catch (error) {
            console.error(error);
            setStatus({
                type: 'error',
                message: 'Erro ao enviar mensagem na conversa!'
            });
        }
    };

    const handleOpenConversation = (conversation, deal) => {
        if (!conversation) {
            setStatus({
                type: 'warning',
                message: 'Este negócio não possui conversa vinculada.'
            });
            return;
        }

        setSelectedDeal(deal);
        setSelectedConversation(conversation);
        setDrawerOpen(true);
        marcar_conversa_como_lida(conversation);
        setStatus({ type: '', message: '' });
    };

    const handleCloseDrawer = () => {
        setDrawerOpen(false);
        setSelectedConversation(null);
        setStatus({ type: '', message: '' });
    };

    const fonteStyle1 = {
        fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
        fontSize: 18,
        lineHeight: 1.1,
        color: isDark ? 'rgba(255,255,255,0.92)' : 'rgba(8,35,60,0.92)',
        fontWeight: 500,
        letterSpacing: '0.01em'
    };

    const fonteStyle2 = {
        fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
        fontSize: 13,
        lineHeight: 1.1,
        color: isDark ? 'rgba(255,255,255,0.65)' : 'rgba(8,35,60,0.65)'
    };

    const fonteStyle3 = {
        fontFamily: "'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
        fontSize: 12,
        lineHeight: 1.1,
        color: isDark ? 'rgba(255,255,255,0.48)' : 'rgba(8,35,60,0.48)'
    };

    async function loadPipeline() {
        if (!appId) return;

        try {
            const response = await api.get(`v1/apps/${appId}/pipelines/`);
            if (!response.data) return;

            if (response.data.length === 0) {
                setStatus({
                    type: 'error',
                    message: 'ERRO! NÃO EXISTEM PIPELINES CADASTRADAS!'
                });
                return;
            }

            const resPipelines = response.data;
            setPipelines(resPipelines);
            const currentPipelineId = wizardData.pipeline.id || resPipelines[0].id;

            if (!wizardData.pipeline.id) {
                setWizardData((prev) => ({
                    ...prev,

                    pipeline: {
                        ...prev.pipeline,

                        id: currentPipelineId
                    }
                }));
            }
        } catch (err) {
            console.error(err);
            setStatus({
                type: 'error',
                message: 'ERRO AO CONSULTAR NEGÓCIOS'
            });
        }
    }

    async function loadStages() {
        if (!appId) return;
        if (!wizardData.pipeline.id) return;

        try {
            const response3 = await api.get(`v1/apps/${appId}/pipelines/${wizardData.pipeline.id}/stages/`);

            if (response3.data.length === 0) {
                setStatus({
                    type: 'error',
                    message: 'ERRO! NÃO EXISTEM STAGES CADASTRADAS!'
                });
                return;
            }

            const stages = response3.data || [];

            setStagesList(stages);
            setStages(stages);
        } catch (err) {
            console.log(`loadStages - erro: ${JSON.stringify(err)}`);
            setStatus({
                type: 'error',
                message: 'ERRO! NÃO EXISTEM STAGES CADASTRADAS!'
            });
        }
    }

    // Cada coluna carrega os próprios negócios paginados (`?stage=&limit=&offset=`)
    // em vez de um único GET trazendo o pipeline inteiro - com muitos
    // negócios isso deixava a tela pesada. No refresh periódico (polling),
    // busca de novo só a quantidade já carregada de cada coluna (via
    // `dealsLoadedCountRef`), pra não "encolher" uma coluna que o usuário
    // já tinha expandido com "Carregar mais".
    async function loadDeals() {
        if (!appId || !wizardData.pipeline.id || !stagesList.length) return;

        // Pipeline vigente NO MOMENTO em que a busca começou - comparado
        // contra `pipelineIdRef.current` (sempre o pipeline selecionado
        // AGORA) antes de aplicar a resposta lá embaixo. Sem isso, uma
        // chamada antiga (trocou de pipeline enquanto ela ainda estava em
        // voo, ou um polling que não foi cancelado a tempo) sobrescrevia a
        // tela com os dados de um pipeline que não é mais o selecionado.
        const pipelineIdDaBusca = wizardData.pipeline.id;

        // LOG TEMPORÁRIO - investigação "pipeline carrega e depois some"
        console.log('[DIAG] loadDeals - início', {
            instance: instanceIdRef.current,
            appId,
            pipelineId: pipelineIdDaBusca,
            stages: stagesList.map((s) => s.id)
        });

        try {
            const respostas = await Promise.all(
                stagesList.map(async (stage) => {
                    const sid = String(stage.id);
                    const limit = Math.max(dealsLoadedCountRef.current[sid] || PAGE_SIZE, PAGE_SIZE);
                    const teamQuery = selectedTeamFilter ? `&team=${selectedTeamFilter}` : '';
                    const url = `v1/apps/${appId}/pipelines/${pipelineIdDaBusca}/deals/?stage=${sid}&limit=${limit}&offset=0${teamQuery}`;
                    try {
                        const res = await api.get(url);
                        console.log('[DIAG] loadDeals - stage OK', { sid, status: res.status, total: res.data?.total, count: res.data?.results?.length });
                        return { sid, deals: res.data?.results || [], total: res.data?.total || 0 };
                    } catch (erroStage) {
                        console.error('[DIAG] loadDeals - stage FALHOU', {
                            sid,
                            url,
                            status: erroStage.response?.status,
                            data: erroStage.response?.data,
                            message: erroStage.message
                        });
                        throw erroStage;
                    }
                })
            );

            if (pipelineIdRef.current !== pipelineIdDaBusca) {
                console.log('[DIAG] loadDeals - resposta descartada (pipeline mudou enquanto a busca estava em andamento)', {
                    instance: instanceIdRef.current,
                    pipelineIdDaBusca,
                    pipelineAtual: pipelineIdRef.current
                });
                return;
            }

            const map = {};
            const meta = {};
            const loadedCounts = {};
            respostas.forEach(({ sid, deals, total }) => {
                map[sid] = deals;
                meta[sid] = { total };
                loadedCounts[sid] = deals.length;
            });

            console.log('[DIAG] loadDeals - setDealsByStage', { instance: instanceIdRef.current, map });
            dealsLoadedCountRef.current = loadedCounts;
            setDealsByStage(map);
            setDealsMeta(meta);
        } catch (erro) {
            console.error('[DIAG] loadDeals - Promise.all rejeitou, estado NÃO foi limpo (mantém o anterior)', erro);
        }
    }

    const handleLoadMore = async (stageId) => {
        const sid = String(stageId);
        const jaCarregados = dealsByStage[sid]?.length || 0;

        setDealsMeta((prev) => ({ ...prev, [sid]: { ...(prev[sid] || {}), loadingMore: true } }));

        try {
            const teamQuery = selectedTeamFilter ? `&team=${selectedTeamFilter}` : '';
            const res = await api.get(
                `v1/apps/${appId}/pipelines/${wizardData.pipeline.id}/deals/?stage=${sid}&limit=${PAGE_SIZE}&offset=${jaCarregados}${teamQuery}`
            );
            const novos = res.data?.results || [];
            const idsExistentes = new Set((dealsByStage[sid] || []).map((d) => d.id));
            const semDuplicados = novos.filter((d) => !idsExistentes.has(d.id));

            setDealsByStage((prev) => {
                const atualizado = { ...prev, [sid]: [...(prev[sid] || []), ...semDuplicados] };
                dealsLoadedCountRef.current = { ...dealsLoadedCountRef.current, [sid]: atualizado[sid].length };
                return atualizado;
            });
            setDealsMeta((prev) => ({ ...prev, [sid]: { total: res.data?.total ?? prev[sid]?.total ?? 0, loadingMore: false } }));
        } catch (error) {
            console.error(error);
            setDealsMeta((prev) => ({ ...prev, [sid]: { ...(prev[sid] || {}), loadingMore: false } }));
        }
    };

    const onDragEnd = async (result) => {
        const { destination, source } = result;
        if (!destination) return;

        const fromStage = source.droppableId;
        const toStage = destination.droppableId;

        if (fromStage === toStage && source.index === destination.index) return;

        // O board renderiza a lista FILTRADA, então os índices do drag vêm
        // dessa lista - precisa mapear de volta pra posição real dentro do
        // array bruto (dealsByStage), já que itens escondidos pelo filtro
        // não somem de fato do array bruto, só não aparecem na tela.
        const filteredFromList = getDealsFiltrados(fromStage);
        const movedDeal = filteredFromList[source.index];
        if (!movedDeal) return;

        // Vizinhos de destino (sem o próprio card movido) - é a partir
        // deles que o backend calcula o novo `ordering` do card movido
        // (`deal_reposition`); com colunas paginadas, reindexar TUDO que
        // está carregado (como antes) deixaria pra trás, fora de ordem, os
        // negócios da mesma coluna que ainda não foram carregados.
        const filteredToListSemMovido = getDealsFiltrados(toStage).filter((d) => d.id !== movedDeal.id);
        const beforeDeal = destination.index > 0 ? filteredToListSemMovido[destination.index - 1] : null;
        const afterDeal = destination.index < filteredToListSemMovido.length ? filteredToListSemMovido[destination.index] : null;

        const newMap = { ...dealsByStage };

        const rawFromArr = Array.from(newMap[fromStage] || []);
        const rawFromIdx = rawFromArr.findIndex((d) => d.id === movedDeal.id);
        if (rawFromIdx === -1) return;
        rawFromArr.splice(rawFromIdx, 1);

        const rawToArr = fromStage === toStage ? rawFromArr : Array.from(newMap[toStage] || []);
        const insertAt = afterDeal ? rawToArr.findIndex((d) => d.id === afterDeal.id) : rawToArr.length;

        movedDeal.stage = toStage;
        rawToArr.splice(insertAt === -1 ? rawToArr.length : insertAt, 0, movedDeal);

        newMap[fromStage] = fromStage === toStage ? rawToArr : rawFromArr;
        newMap[toStage] = rawToArr;

        setDealsByStage(newMap);

        try {
            const response5 = await api.post(`v1/apps/${appId}/deals/${movedDeal.id}/reposition/`, {
                stage: toStage,
                before_id: beforeDeal?.id || null,
                after_id: afterDeal?.id || null
            });
            if (response5.data?.ordering !== undefined) {
                movedDeal.ordering = response5.data.ordering;
            }
        } catch (err) {
            console.error(err);
            loadPipeline();
            setStatus({
                type: 'error',
                message: 'Erro ao reordenar Negócios!'
            });
        }
    };

    const handleChangePipeline = (e) => {
        const pipelineId = e.target.value;

        setWizardData((prev) => ({
            ...prev,
            pipeline: {
                ...prev.pipeline,
                id: pipelineId
            }
        }));
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                px: 2,
                py: 3,
                background: isDark
                    ? `
                    radial-gradient(circle at 52% 8%, rgba(0,183,255,0.12), transparent 18%),
                    radial-gradient(circle at 10% 88%, rgba(0,120,255,0.10), transparent 18%),
                    linear-gradient(180deg, #03070d 0%, #050c15 45%, #02050a 100%)
                `
                    : `
                    radial-gradient(circle at 52% 8%, rgba(0,150,255,0.08), transparent 18%),
                    radial-gradient(circle at 10% 88%, rgba(0,120,255,0.06), transparent 18%),
                    linear-gradient(180deg, #f4faff 0%, #e8f4ff 45%, #f4faff 100%)
                `
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    px: 2,
                    pb: 2,
                    borderBottom: isDark ? '1px solid rgba(110,220,255,0.12)' : '1px solid rgba(0,120,220,0.15)'
                }}
            >
                <Typography
                    variant="h3"
                    gutterBottom
                    sx={{
                        mb: 0,
                        fontWeight: 500,
                        color: isDark ? 'rgba(255,255,255,0.95)' : 'rgba(8,35,60,0.92)',
                        letterSpacing: '0.01em'
                    }}
                >
                    Leads
                </Typography>

                <Button
                    variant="contained"
                    onClick={() => setOpenNewDealDrawer(true)}
                    disabled={!wizardData.pipeline.id || !stages?.length}
                    sx={getHeaderButtonSx(isDark)}
                >
                    Criar Negócio
                </Button>
            </Box>

            {status.message && (
                <Alert
                    severity={status.type}
                    sx={{
                        mt: 2,
                        mb: 2,
                        borderRadius: '18px',
                        background: isDark ? 'rgba(14,26,42,0.88)' : 'rgba(255,255,255,0.9)',
                        color: isDark ? '#fff' : 'rgba(8,35,60,0.92)',
                        border: isDark ? '1px solid rgba(110,220,255,0.12)' : '1px solid rgba(0,120,220,0.15)'
                    }}
                >
                    {status.message}
                </Alert>
            )}

            {/* Select Pipeline */}
            {/* Select Pipeline */}
            {role_user === 'admin' && (
                <Grid item xs={12} sm={6} mt={3}>
                    <TextField
                        select
                        name="pipeline"
                        label="Pipeline"
                        value={wizardData.pipeline.id || ''}
                        onChange={handleChangePipeline}
                        size="small"
                        sx={{
                            width: 280,

                            '& .MuiOutlinedInput-root': {
                                borderRadius: '18px',
                                color: isDark ? '#fff' : 'rgba(8,35,60,0.92)',

                                background: isDark
                                    ? 'linear-gradient(180deg, rgba(12,22,35,0.92), rgba(7,14,24,0.98))'
                                    : 'linear-gradient(180deg, rgba(255,255,255,0.95), rgba(232,244,255,0.9))',

                                backdropFilter: 'blur(14px)',

                                boxShadow: isDark
                                    ? '0 0 30px rgba(0,170,255,0.08), inset 0 0 25px rgba(110,220,255,0.03)'
                                    : '0 0 18px rgba(0,140,255,0.08), inset 0 0 16px rgba(0,140,255,0.03)',

                                transition: 'all .25s ease',

                                '& fieldset': {
                                    borderColor: isDark ? 'rgba(110,220,255,0.15)' : 'rgba(0,120,220,0.18)'
                                },

                                '&:hover fieldset': {
                                    borderColor: isDark ? 'rgba(110,220,255,0.35)' : 'rgba(0,120,220,0.35)'
                                },

                                '&.Mui-focused': {
                                    boxShadow: isDark
                                        ? '0 0 35px rgba(110,220,255,0.20), inset 0 0 25px rgba(110,220,255,0.05)'
                                        : '0 0 22px rgba(0,140,255,0.16), inset 0 0 16px rgba(0,140,255,0.05)'
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: isDark ? '#6edcff' : '#0091ea'
                                }
                            },

                            '& .MuiInputLabel-root': {
                                color: isDark ? 'rgba(255,255,255,0.55)' : 'rgba(8,35,60,0.55)'
                            },

                            '& .MuiInputLabel-root.Mui-focused': {
                                color: isDark ? '#7be9ff' : '#0091ea'
                            },

                            '& .MuiSvgIcon-root': {
                                color: isDark ? '#7be9ff' : '#0091ea'
                            }
                        }}
                        SelectProps={{
                            MenuProps: {
                                PaperProps: {
                                    sx: {
                                        mt: 1,
                                        borderRadius: '18px',
                                        color: isDark ? '#fff' : 'rgba(8,35,60,0.92)',

                                        background: isDark
                                            ? 'linear-gradient(180deg, rgba(8,16,27,0.98), rgba(3,7,14,1))'
                                            : 'linear-gradient(180deg, rgba(255,255,255,0.98), rgba(232,244,255,0.95))',

                                        border: isDark ? '1px solid rgba(110,220,255,0.12)' : '1px solid rgba(0,120,220,0.15)',

                                        boxShadow: isDark ? '0 0 40px rgba(0,170,255,0.12)' : '0 0 24px rgba(0,140,255,0.10)',

                                        '& .MuiMenuItem-root': {
                                            borderRadius: '12px',
                                            mx: 1,
                                            my: 0.5
                                        },

                                        '& .MuiMenuItem-root:hover': {
                                            background: isDark ? 'rgba(110,220,255,0.10)' : 'rgba(0,120,220,0.08)'
                                        },

                                        '& .Mui-selected': {
                                            background: isDark ? 'rgba(110,220,255,0.18) !important' : 'rgba(0,120,220,0.14) !important'
                                        }
                                    }
                                }
                            }
                        }}
                    >
                        {pipelines.map((pipeline) => (
                            <MenuItem key={pipeline.id} value={pipeline.id}>
                                {pipeline.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            )}

            {(role_user === 'admin' || role_user === 'manager' || role_user === 'attendant') && (
                <Box sx={{ mt: 3, px: 2 }}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Button
                            variant="outlined"
                            startIcon={<IconFilter size={18} />}
                            onClick={() => setShowFilters((prev) => !prev)}
                            sx={{ borderRadius: '14px', textTransform: 'none' }}
                        >
                            <Badge badgeContent={filtrosAtivosCount} color="primary" sx={{ '& .MuiBadge-badge': { right: -10 } }}>
                                Filtros
                            </Badge>
                        </Button>

                        {filtrosAtivosCount > 0 && (
                            <Button
                                variant="text"
                                startIcon={<IconFilterOff size={18} />}
                                onClick={limparFiltros}
                                sx={{ textTransform: 'none' }}
                            >
                                Limpar filtros
                            </Button>
                        )}

                        <Button
                            variant="outlined"
                            startIcon={<IconUsers size={18} />}
                            onClick={(e) => setTeamMenuAnchor(e.currentTarget)}
                            sx={{ borderRadius: '14px', textTransform: 'none' }}
                        >
                            {selectedTeamFilter
                                ? `Equipe: ${equipesFiltro.find((eq) => eq.id === selectedTeamFilter)?.name || '...'}`
                                : 'Equipes'}
                        </Button>

                        <Menu anchorEl={teamMenuAnchor} open={!!teamMenuAnchor} onClose={() => setTeamMenuAnchor(null)}>
                            <MenuItem selected={!selectedTeamFilter} onClick={() => handleSelectTeamFilter('')}>
                                Todas
                            </MenuItem>
                            {equipesFiltro.length === 0 && <MenuItem disabled>Nenhuma equipe disponível</MenuItem>}
                            {equipesFiltro.map((eq) => (
                                <MenuItem key={eq.id} selected={selectedTeamFilter === eq.id} onClick={() => handleSelectTeamFilter(eq.id)}>
                                    {eq.name}
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>

                    <Collapse in={showFilters}>
                        <Box sx={getFilterPanelSx(isDark)}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={3}>
                                    {podeFiltrarPorQualquerAtribuido ? (
                                        <Box display="flex" flexDirection="column" gap={0.5}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Atribuído"
                                                value={filtros.assign}
                                                onChange={(e) => setFiltros({ ...filtros, assign: e.target.value })}
                                                sx={getFilterFieldSx(isDark)}
                                            >
                                                <MenuItem value="">Todos</MenuItem>
                                                {teamUsers.map((u) => (
                                                    <MenuItem key={u.id} value={u.id}>
                                                        {u.first_name} {u.last_name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>

                                            {/* Atalho pra não precisar se achar na lista todo vez -
                                                mesmo campo `filtros.assign` do dropdown acima, só
                                                preenchendo/limpando com o próprio id. */}
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={filtros.assign === String(user?.id || '')}
                                                        onChange={(e) =>
                                                            setFiltros({
                                                                ...filtros,
                                                                assign: e.target.checked ? String(user?.id || '') : ''
                                                            })
                                                        }
                                                    />
                                                }
                                                label="Atribuídos a mim"
                                            />
                                        </Box>
                                    ) : (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={filtros.apenasMeus}
                                                    onChange={(e) => setFiltros({ ...filtros, apenasMeus: e.target.checked })}
                                                />
                                            }
                                            label="Meus e sem atribuição"
                                        />
                                    )}
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Canal de mensagem"
                                        value={filtros.canal}
                                        onChange={(e) => setFiltros({ ...filtros, canal: e.target.value })}
                                        sx={getFilterFieldSx(isDark)}
                                    >
                                        <MenuItem value="">Todos</MenuItem>
                                        {CANAIS_MENSAGEM.map((c) => (
                                            <MenuItem key={c.value} value={c.value}>
                                                {c.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        label="Criado a partir de"
                                        InputLabelProps={{ shrink: true }}
                                        value={filtros.dataInicio}
                                        onChange={(e) => setFiltros({ ...filtros, dataInicio: e.target.value })}
                                        sx={getFilterFieldSx(isDark)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        label="Criado até"
                                        InputLabelProps={{ shrink: true }}
                                        value={filtros.dataFim}
                                        onChange={(e) => setFiltros({ ...filtros, dataFim: e.target.value })}
                                        sx={getFilterFieldSx(isDark)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Nome do contato (canal)"
                                        value={filtros.contatoCanal}
                                        onChange={(e) => setFiltros({ ...filtros, contatoCanal: e.target.value })}
                                        sx={getFilterFieldSx(isDark)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Nome do cliente cadastrado"
                                        value={filtros.nomeCliente}
                                        onChange={(e) => setFiltros({ ...filtros, nomeCliente: e.target.value })}
                                        sx={getFilterFieldSx(isDark)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Organização"
                                        value={filtros.nomeOrganizacao}
                                        onChange={(e) => setFiltros({ ...filtros, nomeOrganizacao: e.target.value })}
                                        sx={getFilterFieldSx(isDark)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <Box display="flex" gap={1}>
                                        <TextField
                                            size="small"
                                            type="number"
                                            label="Valor mín."
                                            disabled={filtros.semValor}
                                            value={filtros.valorMin}
                                            onChange={(e) => setFiltros({ ...filtros, valorMin: e.target.value })}
                                            sx={getFilterFieldSx(isDark)}
                                        />
                                        <TextField
                                            size="small"
                                            type="number"
                                            label="Valor máx."
                                            disabled={filtros.semValor}
                                            value={filtros.valorMax}
                                            onChange={(e) => setFiltros({ ...filtros, valorMax: e.target.value })}
                                            sx={getFilterFieldSx(isDark)}
                                        />
                                    </Box>
                                    <FormControlLabel
                                        sx={{ mt: 0.5 }}
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={filtros.semValor}
                                                onChange={(e) => setFiltros({ ...filtros, semValor: e.target.checked })}
                                            />
                                        }
                                        label="Sem valor"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            display: 'block',
                                            mb: 0.5,
                                            color: isDark ? 'rgba(255,255,255,0.55)' : 'rgba(8,35,60,0.55)'
                                        }}
                                    >
                                        Temperatura
                                    </Typography>
                                    <Box display="flex" gap={1} flexWrap="wrap">
                                        {TEMPERATURAS.map((t) => (
                                            <Chip
                                                key={t.value}
                                                label={t.label}
                                                clickable
                                                color={filtros.temperaturas.includes(t.value) ? 'primary' : 'default'}
                                                onClick={() => toggleTemperatura(t.value)}
                                            />
                                        ))}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Collapse>
                </Box>
            )}

            <Box sx={getBoardContainerSx(isDark)}>
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        pointerEvents: 'none',
                        borderRadius: '30px',
                        boxShadow: isDark
                            ? 'inset 0 0 120px rgba(0,170,255,0.05), inset 0 0 1px rgba(130,235,255,0.30)'
                            : 'inset 0 0 80px rgba(0,140,255,0.04), inset 0 0 1px rgba(0,140,255,0.20)'
                    }}
                />

                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                        width: '100%',
                        overflowX: 'auto',
                        flexWrap: 'nowrap',
                        pb: 1
                    }}
                >
                    <DragDropContext onDragEnd={onDragEnd}>
                        {stages.map((stage, idx) => (
                            <Droppable droppableId={`${stage.id}`} key={stage.id}>
                                {(provided) => (
                                    <Box
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        sx={{
                                            flex: '1 1 280px',
                                            minWidth: 280,
                                            maxWidth: 360,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            position: 'relative',
                                            pr: 1.5,
                                            borderRight:
                                                idx !== stages.length - 1
                                                    ? isDark
                                                        ? '1px solid rgba(110,220,255,0.10)'
                                                        : '1px solid rgba(0,120,220,0.12)'
                                                    : 'none'
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                minHeight: 96,
                                                px: 1.5,
                                                py: 1,
                                                borderBottom: isDark ? '1px solid rgba(110,220,255,0.08)' : '1px solid rgba(0,120,220,0.10)'
                                            }}
                                        >
                                            <Typography style={fonteStyle1}>{stage.name}</Typography>

                                            <Typography sx={{ mt: 1 }} style={fonteStyle2}>
                                                R$
                                                {getDealsFiltrados(stage.id)
                                                    .reduce((acc, deal) => acc + parseFloat(deal.value || 0), 0)
                                                    .toFixed(2)}
                                            </Typography>

                                            <Typography sx={{ mt: 1 }} style={fonteStyle3}>
                                                {getDealsFiltrados(stage.id).length}{' '}
                                                {getDealsFiltrados(stage.id).length > 1 ? 'negócios' : 'negócio'}
                                            </Typography>
                                        </Box>

                                        <Card
                                            variant="outlined"
                                            sx={{
                                                mt: 1.2,
                                                width: '100%',
                                                height: 'calc(100vh - 260px)',
                                                borderRadius: '24px',
                                                border: isDark ? '1px solid rgba(110,220,255,0.10)' : '1px solid rgba(0,120,220,0.14)',
                                                background: isDark
                                                    ? idx === stages.length - 1
                                                        ? 'linear-gradient(180deg, rgba(18,44,72,0.60), rgba(8,18,32,0.70))'
                                                        : 'linear-gradient(180deg, rgba(8,16,27,0.56), rgba(4,10,18,0.72))'
                                                    : idx === stages.length - 1
                                                    ? 'linear-gradient(180deg, rgba(215,240,255,0.85), rgba(195,230,255,0.65))'
                                                    : 'linear-gradient(180deg, rgba(255,255,255,0.75), rgba(230,245,255,0.55))',
                                                backdropFilter: 'blur(14px)',
                                                boxShadow: isDark
                                                    ? idx === stages.length - 1
                                                        ? '0 0 26px rgba(0,183,255,0.08), inset 0 0 18px rgba(95,220,255,0.04)'
                                                        : 'inset 0 0 18px rgba(95,220,255,0.02)'
                                                    : idx === stages.length - 1
                                                    ? '0 0 20px rgba(0,140,255,0.10), inset 0 0 16px rgba(0,140,255,0.05)'
                                                    : 'inset 0 0 14px rgba(0,140,255,0.03)',
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }}
                                        >
                                            <CardContent
                                                sx={{
                                                    flex: 1,
                                                    overflowY: 'auto',
                                                    overflowX: 'hidden',
                                                    p: 1.2,
                                                    '&::-webkit-scrollbar': {
                                                        width: '8px'
                                                    },
                                                    '&::-webkit-scrollbar-thumb': {
                                                        background: isDark ? 'rgba(110,220,255,0.18)' : 'rgba(0,120,220,0.20)',
                                                        borderRadius: '999px'
                                                    }
                                                }}
                                            >
                                                {getDealsFiltrados(stage.id).map((deal, index) => (
                                                    <Draggable draggableId={`${deal.id}`} index={index} key={deal.id}>
                                                        {(provided2) => (
                                                            <Box
                                                                ref={provided2.innerRef}
                                                                {...provided2.draggableProps}
                                                                {...provided2.dragHandleProps}
                                                                sx={{
                                                                    userSelect: 'none',
                                                                    mb: 1.2
                                                                }}
                                                            >
                                                                {deal.conversation ? (
                                                                    <DealConversationCard
                                                                        deal={deal}
                                                                        appId={appId}
                                                                        onClick={() =>
                                                                            handleOpenConversation(deal.conversation_detail, deal)
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <Box
                                                                        onClick={() => {
                                                                            setSelectedDeal(deal);
                                                                            setOpenDealDrawer(true);
                                                                        }}
                                                                    >
                                                                        <DealCard deal={deal} />
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}

                                                {(dealsByStage[String(stage.id)]?.length || 0) <
                                                    (dealsMeta[String(stage.id)]?.total || 0) && (
                                                    <Button
                                                        fullWidth
                                                        size="small"
                                                        onClick={() => handleLoadMore(stage.id)}
                                                        disabled={dealsMeta[String(stage.id)]?.loadingMore}
                                                        sx={{
                                                            mt: 0.5,
                                                            borderRadius: '14px',
                                                            textTransform: 'none',
                                                            color: isDark ? 'rgba(255,255,255,0.7)' : 'rgba(8,35,60,0.7)',
                                                            border: isDark
                                                                ? '1px dashed rgba(110,220,255,0.25)'
                                                                : '1px dashed rgba(0,120,220,0.30)'
                                                        }}
                                                    >
                                                        {dealsMeta[String(stage.id)]?.loadingMore
                                                            ? 'Carregando...'
                                                            : `Carregar mais (${
                                                                  (dealsMeta[String(stage.id)]?.total || 0) -
                                                                  (dealsByStage[String(stage.id)]?.length || 0)
                                                              } restantes)`}
                                                    </Button>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </Box>
                                )}
                            </Droppable>
                        ))}
                    </DragDropContext>
                </Box>
            </Box>

            <JanelaConversa
                status_drawer={drawerOpen}
                onCloseDrawer={handleCloseDrawer}
                conversa_selecionada={selectedConversation}
                onConversationUpdate={setSelectedConversation}
                mensagens={messages}
                appId={appId}
                conversa_lida={marcar_conversa_como_lida}
                deal={selectedDeal}
                pipelineId={wizardData.pipeline.id}
                hasMoreOlderMessages={hasMoreOlderMessages}
                loadingOlderMessages={loadingOlderMessages}
                onLoadOlderMessages={loadOlderMessages}
            />

            <Drawer
                anchor="right"
                open={openNewDealDrawer}
                onClose={() => setOpenNewDealDrawer(false)}
                PaperProps={{
                    sx: {
                        width: '40vw',
                        p: 0,
                        color: isDark ? '#fff' : 'rgba(8,35,60,0.92)',
                        background: isDark
                            ? 'linear-gradient(180deg, rgba(5,12,20,0.98), rgba(3,7,14,1))'
                            : 'linear-gradient(180deg, rgba(255,255,255,0.98), rgba(232,244,255,0.95))',
                        borderLeft: isDark ? '1px solid rgba(110,220,255,0.12)' : '1px solid rgba(0,120,220,0.15)',
                        boxShadow: isDark ? '-20px 0 60px rgba(0,160,255,0.08)' : '-20px 0 40px rgba(0,140,255,0.08)'
                    }
                }}
            >
                {openNewDealDrawer && (
                    <NewDeal
                        pipelineId={wizardData.pipeline.id}
                        firstStageId={stages[0]?.id || null}
                        onClose={() => setOpenNewDealDrawer(false)}
                        onSaved={loadPipeline}
                    />
                )}
            </Drawer>

            <Drawer
                anchor="right"
                open={openDealDrawer}
                onClose={() => setOpenDealDrawer(false)}
                PaperProps={{
                    sx: {
                        width: '40vw',
                        p: 0,
                        color: isDark ? '#fff' : 'rgba(8,35,60,0.92)',
                        background: isDark
                            ? 'linear-gradient(180deg, rgba(5,12,20,0.98), rgba(3,7,14,1))'
                            : 'linear-gradient(180deg, rgba(255,255,255,0.98), rgba(232,244,255,0.95))',
                        borderLeft: isDark ? '1px solid rgba(110,220,255,0.12)' : '1px solid rgba(0,120,220,0.15)',
                        boxShadow: isDark ? '-20px 0 60px rgba(0,160,255,0.08)' : '-20px 0 40px rgba(0,140,255,0.08)'
                    }
                }}
            >
                {selectedDeal && (
                    <DealDrawer
                        deal={selectedDeal}
                        onClose={() => setOpenDealDrawer(false)}
                        onSaved={loadPipeline}
                        pipelineId={wizardData.pipeline.id}
                    />
                )}
            </Drawer>
        </Box>
    );
};

export default PipelineMain;
